import { initScrollAnimations } from './components/animations';
import { initFAQ } from './components/faq';
import { initSlideshow } from './components/slideshow';
import { initSmoothScroll } from './components/navigation';
import { initStickyCTA } from './components/sticky-cta';
import { initAppLinks } from './components/app-links';
import { initShareButton } from './components/share-button';

// Initialize all components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initFAQ();
  initSlideshow();
  initSmoothScroll();
  initStickyCTA();
  initAppLinks();
  initShareButton();
});
